import callApi from './callApi';
export const apiRoot = `${process.env.REACT_APP_API_URL}/api/v1/`;

export const generateTestPlan = (data) => {
  const url = `testcases/generate-test-plan`;
  return callApi(url, {}, 'POST', data);
};

export const createTestCycleWithPlan = async (payload, projectId) => {
  const url = `testcases/create-test-cycle?projectId=${projectId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'POST', body);
};

export const getDefectIntelligence = async (file) => {
  const url = `failures/defect-intelligence/classify`;
  const accessToken = localStorage.getItem('token');

  const form = new FormData();
  form.append('file', file);

  const response = await fetch(apiRoot + url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(accessToken && { Authorization: `${accessToken}` }),
    },
    body: form,
  });

  const newAccessToken = response.headers.get('x-access-token');
  if (newAccessToken) {
    localStorage.setItem('token', `Bearer ${newAccessToken}`);
  }

  if (!response.ok) {
    let errorData = {};
    try { errorData = await response.json(); } catch {}
    // eslint-disable-next-line no-throw-literal
    throw {
      message: errorData?.error?.message || errorData?.message || 'Something went wrong',
      status: response.status,
      data: errorData,
    };
  }

  return response.json();
};